import CbSelect from './src/select.vue';

CbSelect.install = function(Vue) {
  Vue.component(CbSelect.name, CbSelect);
};

export default CbSelect;
